import React from 'react';
import { connect } from 'react-redux';
import * as reducers from 'Store/reducers';
import { sendAnalyticsEventById } from 'Store/stats/actions';

import AccessCode from 'Components/AccessCode';

class SchoolCode extends React.Component {
  static sendAnalyticsOnTimeout(props) {
    window.setTimeout(props.sendAnalyticsEventById, 3000, props.hintId);
  }

  componentDidMount() {
    if (
      typeof this.props.hasUIHintBeenSeen === 'boolean' &&
      this.props.hasUIHintBeenSeen === false
    ) {
      SchoolCode.sendAnalyticsOnTimeout(this.props);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.hasUIHintBeenSeen !== this.props.hasUIHintBeenSeen &&
      nextProps.hasUIHintBeenSeen === false
    ) {
      SchoolCode.sendAnalyticsOnTimeout(nextProps);
    }
  }

  render() {
    const { schoolCode, hasUIHintBeenSeen } = this.props;

    if (!schoolCode) return null;
    return (
      <AccessCode
        type="school"
        code={schoolCode}
        fadeInTooltip={!hasUIHintBeenSeen}
      />
    );
  }
}

const mapStateToProps = state => {
  const hintId = 'tooltip_schools_code';
  // We use this one to make sure we don’t show the code again.
  const embarrassingOldId = 'tooltip-school-scodes';
  const activeSchoolId = reducers.getActiveSchoolId(state);
  const activeSchool = reducers.getSchool(state, activeSchoolId);
  return {
    hintId,
    schoolCode:
      activeSchool && activeSchool.school_codes
        ? activeSchool.school_codes[0]
        : null,
    hasUIHintBeenSeen:
      reducers.getHasUIHintBeenSeen(state, hintId) ||
      reducers.getHasUIHintBeenSeen(state, embarrassingOldId),
  };
};

export default connect(mapStateToProps, { sendAnalyticsEventById })(SchoolCode);
